<template>
  <IEScreen v-if="isIE" />
  <AgeGate v-else />
</template>

<script>
import IEScreen from "./components/IEScreen";
import AgeGate from "./components/AgeGate";

export default {
  name: "App",
  components: {
    IEScreen,
    AgeGate,
  },
  computed: {
    isIE() {
      const ua = window.navigator.userAgent;
      return /MSIE|Trident/.test(ua);
    },
  },
};
</script>

<style lang="stylus">
@import './styles/main.styl';
</style>
